import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import selectRoot from "./root"

export default function selectProcess(state, model, id) {
  const { processes } = selectRoot(state)

  const { name } = normalizeModel(model)
  return processes[name] && processes[name].items[id]
    ? processes[name].items[id]
    : null
}
